import React from 'react';
import PropTypes from 'react-proptypes';

export default class KeyboardEvents extends React.Component {
  static propTypes = {
    onKeyUp: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  componentDidMount() {
    this.bindEvents();
  }

  componentWillUnmount() {
    this.unbindEvents();
  }

  render() {
    return (
      <div className="keyboard-events" style={{ width: '100%' }}>
        {this.props.children}
      </div>
    );
  }

  bindEvents() {
    document.addEventListener('keyup', this.handleKeyUp);
  }

  unbindEvents() {
    document.removeEventListener('keyup', this.handleKeyUp);
  }

  handleKeyUp = (event) => {
    // @ts-ignore
    this.props.onKeyUp(event);
  };
}
